<form class="w-2/3 overflow-hidden" [formGroup]="form()">
  <hlm-field>
    <label hlmLabel for="savoirs-scientifiques">Savoirs scientifiques et culturel</label>
    <input id="savoirs-scientifiques" hlmInput type="text" formControlName="savoirsScientifiquesCulturel" />
    <hlm-field-description>Si vide, libre au choix de l'apprenant.</hlm-field-description>
  </hlm-field>
</form>
